import React from "react";
import { TodoContext } from "../TodoContext";
import "./TodoForm.css"


function TodoForm(){

    const [newTodoValue, setNewTodoValue] = React.useState('');

    const {
        addTodo,
        setOpenModal,
    } = React.useContext(TodoContext);

    const onCancel = () =>{
        setOpenModal(false);
    };

    const onChange= (event) =>{
        setNewTodoValue(event.target.value);
    };

    const onSubmit = (event) =>{
         // prevent default para evitar recargar la página
        event.preventDefault();
        addTodo(newTodoValue);
        setOpenModal(false);
    }

    return(
        <form onSubmit={onSubmit} className="TodoForm">
            <label>Create a new task</label>
            <textarea
                value={newTodoValue}
                onChange={onChange}
                placeholder="Type in a task to save"
            />

           <div  className="TodoForm-buttonContainer">
                <button
                type="button"
                onClick={onCancel}
                className="TodoForm-button TodoForm-button--cancel"
                >Cancel</button>

                <button
                type="submit"
                className="TodoForm-button TodoForm-button--add"
                >Save</button>

            </div> 
        </form>
    )
}


export {TodoForm}